import { E as EMPTY_ICON_HEIGHT, a as EMPTY_ICON_WIDTH } from './emptyIcon-D6JwmRyF.js';

// Icon definiton removed of all properties
const sanitizedIcon = {
  width: EMPTY_ICON_WIDTH,
  height: EMPTY_ICON_HEIGHT,
  path: ''
};

/**
 * If the given icon does not contain a standard height, width, or path,
 * it will be sanitized and an emmpty icon will be returned.
 */
const getSanitizedIcon = icon => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [iconWidth, iconHeight, iconLigatures, iconUnicode, iconPathData] = icon;
  const sanitizedWidth = parseInt(String(iconWidth), 10);
  if (sanitizedWidth <= 0) {
    return sanitizedIcon;
  }
  const sanitizedHeight = parseInt(String(iconHeight), 10);
  if (sanitizedHeight <= 0) {
    return sanitizedIcon;
  }
  // Regexp of all characters allowed in an SVG path
  const pathRegex = new RegExp(/^[MLHVCSQTAZ0-9,.\t -]{0,5000}$/i);
  if (Array.isArray(iconPathData)) {
    for (let i = 0; i < iconPathData.length; i++) {
      if (typeof iconPathData[i] !== 'string' || !pathRegex.test(iconPathData[i])) {
        return sanitizedIcon;
      }
    }
  } else if (typeof iconPathData !== 'string' || !pathRegex.test(iconPathData)) {
    return sanitizedIcon;
  }
  return {
    width: iconWidth,
    height: iconHeight,
    path: iconPathData
  };
};

export { getSanitizedIcon as g };
//# sourceMappingURL=getSanitizedIcon-CIZy47UD.js.map
